// Copyright (c) 2025, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content. 

import React from "react";
import { View } from "@view/index";
import { Role } from "@slices/authSlice/auth";
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import RuleFolderIcon from '@mui/icons-material/RuleFolder';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { isIncludedRole } from "@utils/utils";
import { RouteObject, NonIndexRouteObject } from "react-router-dom";

export interface RouteObjectWithRole extends NonIndexRouteObject {
  allowRoles: string[];
  icon:
  | React.ReactElement<any, string | React.JSXElementConstructor<any>>
  | undefined;
  text: string;
  children?: RouteObjectWithRole[];
  bottomNav?: boolean;
}

interface RouteDetail {
  path: string;
  allowRoles: string[];
  icon:
  | React.ReactElement<any, string | React.JSXElementConstructor<any>>
  | undefined;
  text: string;
  bottomNav?: boolean;
}

export const routes: RouteObjectWithRole[] = [
  {
    path: "/repository-requests/*",
    text: "Repository Requests",
    icon: React.createElement(CreateNewFolderIcon),
    element: React.createElement(View.member),
    allowRoles: [Role.ADMIN,Role.APPROVER, Role.EMPLOYEE],
  },
  {
    path: "/review-repository-requests/*",
    text: "Review Repository Requests",
    icon: React.createElement(RuleFolderIcon),
    element: React.createElement(View.lead),
    allowRoles: [Role.APPROVER],
  },
  {
    path: "/Admin/*",
    text: "Admin",
    icon: React.createElement(AdminPanelSettingsIcon),
    element: React.createElement(View.admin),
    allowRoles: [Role.ADMIN],
  },
  {
    path: "/help/*",
    text: "Help",
    icon: React.createElement(HelpOutlineIcon),
    element: React.createElement(View.help),
    allowRoles: [Role.ADMIN, Role.APPROVER, Role.EMPLOYEE],
    bottomNav: true,
  },
];
export const getActiveRoutesV2 = (
  routes: RouteObjectWithRole[] | undefined,
  roles: string[]
): RouteObjectWithRole[] => {
  if (!routes) return [];
  var routesObj: RouteObjectWithRole[] = [];
  routes.forEach((routeObj) => {
    if (isIncludedRole(roles, routeObj.allowRoles)) {
      routesObj.push({
        ...routeObj,
        children: getActiveRoutesV2(routeObj.children, roles),
      });
    }
  });

  return routesObj;
};

export const getActiveRoutes = (roles: string[]): RouteObject[] => {
  var routesObj: RouteObject[] = [];
  routes.forEach((routeObj) => {
    if (isIncludedRole(roles, routeObj.allowRoles)) {
      routesObj.push({
        ...routeObj,
      });
    }
  });
  return routesObj;
};

export const getActiveRouteDetails = (roles: string[]): RouteDetail[] => {
  var routesObj: RouteDetail[] = [];
  routes.forEach((routeObj) => {
    if (isIncludedRole(roles, routeObj.allowRoles)) {
      routesObj.push({
        path: routeObj.path ? routeObj.path : "",
        ...routeObj,
      });
    }
  });
  return routesObj;
};
